import React from "react";

// Tip: point these to your local brand logo files.
// Example paths are illustrative. Adjust to your assets.
import toyota from "../assets/images/logos/Toyota.png";
import ford from "../assets/images/logos/ford.png";
import kia from "../assets/images/logos/kia.png";
import porsche from "../assets/images/logos/porsche.png";
import ChanganLogo from "../assets/images/logos/Changan-Logo.png";
import genesis from "../assets/images/logos/genesis.png";
import audi from "../assets/images/logos/audi.png";
import bmw from "../assets/images/logos/bmw.png";
import Chery from "../assets/images/logos/Chery.png";
import isuzu from "../assets/images/logos/isuzu.png";
import jetour from "../assets/images/logos/jetour.png";
import compact from "../assets/images/logos/compact.png";
import jeep from "../assets/images/logos/jeep.png";
import logo from "../assets/images/logos/brand-3.png";
import brand from "../assets/images/logos/brand.png";
import brand4 from "../assets/images/logos/brand-4.png";
import luxury from "../assets/images/logos/luxury.png";
import Mercedes from "../assets/images/logos/Mercedes.png";
import purepng from "../assets/images/logos/purepng.png";
import nissan from "../assets/images/logos/nissan.png"

const logos = [
  ChanganLogo, bmw, Mercedes,logo, genesis,brand, toyota, porsche, kia,ford,isuzu, nissan,brand4, audi,  Chery, jetour, compact, jeep, luxury,purepng
];

export default function MobileBrandLogos() {
  const first16 = logos.slice(0, 20);
  return (
    <div className="m-logos" dir="rtl" aria-label="شعارات شركات السيارات">
      <div className="m-logos-track"> {/* now a GRID, not a slider */}
        {first16.map((src, i) => (
          <div className="m-logo" key={i}>
            <img src={src} alt="" loading="lazy" />
          </div>
        ))}
      </div>
    </div>
  );
}
